var React = require('react');

function Followers (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"22","height":"22","fill":"none","key":0}),React.createElement("g",{"transform":"translate(-1 -1)","key":1},[React.createElement("path",{"d":"M12,16.25a4.249,4.249,0,0,1-3.741-2.232l-1.319.714a5.752,5.752,0,0,0,10.121,0l-1.319-.714A4.249,4.249,0,0,1,12,16.25Z","fill":"#fff","key":0}),React.createElement("path",{"d":"M8.25,9.75a1,1,0,1,1,1,1A1,1,0,0,1,8.25,9.75Z","fill":"#fff","key":1}),React.createElement("path",{"d":"M14.75,8.75a1,1,0,1,0,1,1A1,1,0,0,0,14.75,8.75Z","fill":"#fff","key":2}),React.createElement("path",{"d":"M12,2.25A9.75,9.75,0,1,0,21.75,12,9.75,9.75,0,0,0,12,2.25ZM3.75,12A8.25,8.25,0,1,1,12,20.25,8.25,8.25,0,0,1,3.75,12Z","fill":"#fff","fillRule":"evenodd","key":3})])]);
}

Followers.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Followers;

Followers.default = Followers;
